// extracted by mini-css-extract-plugin
export default {"hearderStyle":"ErrorDialogForServerError_hearderStyle__AWlbo","contentStyle":"ErrorDialogForServerError_contentStyle__qDomc","okButton":"ErrorDialogForServerError_okButton__c-3Mx"};